<template>
  <LayoutGradient :title="$t('core_companies.form.empresa_principal')" icon="fa-list">
    <template v-slot:headerRight>
      <b-btn-group>
        <b-btn variant="outline-info" @click="$router.back()">
          <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
        </b-btn>
        <b-button v-if="!$route.params.id"
                  variant="outline-info"
                  v-b-modal="'modal-import'">
            {{ $t('core_companies.form.importar_vs') }}
        </b-button>
      </b-btn-group>
    </template>
    <b-modal id="modal-import" :title="$t('core_companies.form.importar_empresa_vs')"
             @shown="$store.commit('corecompanies/setAll',[])" hide-footer>
      <b-input-group>
        <b-select v-model="importing.param">
          <b-select-option value="nome">{{ $t('core_companies.form.nome') }}</b-select-option>
          <b-select-option value="mnemonic">{{ $t('core_companies.form.mnemonico') }}</b-select-option>
        </b-select>
        <b-form-input v-model="importing.text"/>
        <b-input-group-append>
          <b-button variant="primary" @click="listCompanies">{{ $t('core_companies.form.pesquisar') }}</b-button>
        </b-input-group-append>
      </b-input-group>
      <b-overlay :show="isLoading">
        <b-table v-if="corecompanies.length > 0" :items="corecompanies" :fields="['nome','---']" borderless>
          <template v-slot:cell(---)="{ item: { id } }">
            <b-button @click="importCompany(id)">{{ $t('core_companies.form.importar') }}</b-button>
          </template>
        </b-table>
      </b-overlay>
    </b-modal>

    <div class="m-3 mt-n10">
      <b-card>
        <SimpleForm :fields="fields" :model="model" @submit="onSubmit">          
          <template v-slot:field(info.provider_id)>
            <b-form-group :label="$t('core_companies.form.provider')">
              <SelectCoreCompanies :model="companies" @input="evt => model.provider_id = (evt) ? evt.value : null " />
            </b-form-group>
          </template>
        </SimpleForm>
      </b-card>
    </div>
  </LayoutGradient>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import LayoutGradient from "@/templates/LayoutGradient";
import SimpleForm from "@/components/FormGenerator/SimpleForm";
import FieldGenerator from "@/components/FormGenerator/FieldGenerator";
import CompaniesRepository from "@/repositories/CompaniesRepository";
import SelectCoreCompanies from "@/pages/corecompanies/components/SelectCoreCompanies";

export default {
  name: "Form",
  components: {FieldGenerator, SimpleForm, LayoutGradient, SelectCoreCompanies},
  computed: {
    ...mapGetters({      
      corecompanies: 'corecompanies/all',
      company: 'corecompanies/current',
      isLoading: 'corecompanies/isLoading'
    }),
    companies() {
      if (this.model.provider_id && this.corecompanies) {

        if (this.corecompanies.filter(c => this.model.provider_id === c.id).length === 0){
          this['corecompanies/search']({filters: [['id', '=', this.model.provider_id]]})
        }

        const model = this.corecompanies.find(c => this.model.provider_id === c.id)
        if (!model) {
          return {}
        }
        return {
          value: model.id,
          label: model.name
        }
      }
      return {}
    }
  },
  data() {
    return {
      fields: [
        {
          fieldsetLabel: this.$t('core_companies.form.informacoes'),
          fieldset: 'info',
          fields: [
            {label: this.$t('core_companies.form.mnemonico'), name: 'mnemonic', description: this.$t('core_companies.form.mnemonico_descricao')},
            {label: this.$t('core_companies.form.nome'), name: 'name', description: this.$t('core_companies.form.nome'),},
            {label: 'Veus ID', name: 'veus_company_id', description: this.$t('core_companies.form.veus_id_descricao'), type: 'number'},
            {label: 'CNPJ', name: 'cnpj', description: this.$t('core_companies.form.cnpj_empresa_descricao'),},
            {label: 'CNES', name: 'cnes', description: this.$t('core_companies.form.cnes_empresa_descricao'),},
            {label: 'Fornecedor', name: 'provider_id', description: "Fornecedor de VNS"},
          ]
        },
        {
          fieldsetLabel: 'RNDS',
          fieldset: 'rnds',
          fields: [
            {label: this.$t('core_companies.form.id_solicitacao'), name: 'rnds_solicitacao', description: this.$t('core_companies.form.id_solicitacao_descricao')},
          ]
        },
        {
          fieldsetLabel: this.$t('core_companies.form.controle_qualidade'),
          fieldset: 'qualidade',
          fields: [
            {label: this.$t('core_companies.form.usuario'), name: 'quality_control_user', description: this.$t('core_companies.form.usuario_descricao')},
            {label: this.$t('core_companies.form.senha'), name: 'quality_control_password', description: this.$t('core_companies.form.senha_descricao')}
          ]
        }
      ],
      model: {
        id: null,
        mnemonic: '',
        name: '',
        veus_company_id: null,
        cnpj: '',
        cnes: '',
        rnds_solicitacao: '',
        provider_id: ''
      },
      importing: {
        param: 'nome',
        text: null,
        id: null
      }
    }
  },
  methods: {
    ...mapActions([
      'corecompanies/listOne',
      'corecompanies/listInVs',
      'corecompanies/listOneInVs',
      'corecompanies/search',
    ]),
    async listCompanies() {
      let obj = {}
      obj[this.importing.param] = this.importing.text
      await this['corecompanies/listInVs'](obj)
    },
    async importCompany(id) {
      await this['corecompanies/listOneInVs'](id)
      this.model = {
        id: null,
        mnemonic: this.company.mnm_empresa,
        name: this.company.nome,
        veus_company_id: this.company.id,
        cnpj: this.company.cnpj,
        cnes: this.company.cnes,
        rnds_solicitacao: null,
        provider_id: this.company.provider_id,
      }
      this.$store.commit('corecompanies/setCurrent', {})
      this.$store.commit('corecompanies/setAll', {})
      this.$bvModal.hide('modal-import')
    },
    onSubmit() {
      if (this.$route.params.id) {
        this.update()
      }else {
        this.create()
      }
    },
    create() {
      CompaniesRepository.post(this.model).then(() => {
        this.$snotify.success(this.$t('core_companies.form.empresa_criada_sucesso'))
        this.$router.push({name: 'corecompanies.index'})
      }).catch(error => {
        if (error.response.status === 422) {
          CompaniesRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      CompaniesRepository.put(this.company.id, this.model).then(() => {
        this.$snotify.success(this.$t('core_companies.form.empresa_atualizada_sucesso'))
        this.$router.push({name: 'corecompanies.index'})
      }).catch(error => {
        if (error.response.status === 422) {
          CompaniesRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('corecompanies/setCurrent', {})
    if (this.$route.params.id) {
      await this['corecompanies/listOne'](this.$route.params.id)
      this.model = {...this.model, ...this.company}
    }
  }
}
</script>

<style scoped>
</style>